import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm } from "react-hook-form";
import * as Form from "@radix-ui/react-form";
import { toast } from "react-toastify";
import axios from "../../api/axios";
import CustomLabel from "../CustomLabel";
import messages from "./messages";
import Logo from "../Logo";
import {
  Button,
  Container,
  NavigationButtons,
  SectionWrapper,
  SpinnerIcon,
} from "../Styles";
import PasswordInput from "./PasswordInput";
import Header from "../reuse/Header";

function ResetPassword() {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isValid, isDirty },
  } = useForm({
    mode: "onChange",
  });

  const navigate = useNavigate();

  const params = useParams();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const intl = useIntl();

  const passwordMessage = "Password / Contraseña"; // intl.formatMessage(messages.password);
  const confirmPasswordMessage = "Confirm Password / confirmar Contraseña"; // intl.formatMessage(messages.confirm_password);

  const resetPassword = "RESET PASSWORD / RESTABLECER LA CONTRASEÑA"; // intl.formatMessage(messages.reset_password);

  // Watch the value of the password field
  const watchPassword = watch("password");

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      const { password } = values;

      const response = await axios.post("/auth/resetPassword", {
        password: btoa(password),
        token: params.token,
      });

      toast.success(intl.formatMessage(messages.reset_password_success));

      // form.resetFields();

      navigate("/");
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || intl.formatMessage(messages.error);

      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const validatePasswordMatch = (value) => {
    return (
      value === watchPassword ||
      intl.formatMessage(messages.passwords_do_not_match)
    );

    /*
    const password = event.target.form.password.value;
    const confirmPassword = event.target.value;
    if (password !== confirmPassword) {
      setError("confirmPassword", {
        type: "manual",
        message: intl.formatMessage(messages.passwords_do_not_match),
      });
    } else {
      clearErrors("confirmPassword");
    }
    */
  };

  return (
    <Container>
      <SectionWrapper width="540px">
        <Logo />
        <Header text={resetPassword} />
        {/* <Header>
          <FormattedMessage {...messages.reset_password} />
        </Header> */}
        <Form.Root onSubmit={handleSubmit(onSubmit)}>
          <PasswordInput
            label={<CustomLabel label={passwordMessage} required />}
            name="password"
            register={register}
            errors={isSubmitted && errors}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
          />

          <PasswordInput
            label={<CustomLabel label={confirmPasswordMessage} required />}
            name="confirmPassword"
            register={register}
            errors={isSubmitted && errors}
            showPassword={showConfirmPassword}
            setShowPassword={setShowConfirmPassword}
            validatePasswordMatch={validatePasswordMatch}
          />

          <Button type="submit" disabled={!isValid || !isDirty || loading}>
            {loading ? (
              <>
                <SpinnerIcon /> Loading
              </>
            ) : (
              // <FormattedMessage {...messages.submit} />
              "reset password / restablecer la contraseña"
            )}
          </Button>

          <NavigationButtons>
            <Link to="/">
              {/* <FormattedMessage {...messages.login} /> */}
              Login / Acceso
            </Link>
          </NavigationButtons>
        </Form.Root>
      </SectionWrapper>
    </Container>
  );
}

export default ResetPassword;
